import React from 'react'
import { Trans } from 'react-i18next'
import { connect } from 'react-redux'
import { orderBy } from 'lodash'

import { Format, Parse } from 'services/Dates'
import { getUserName, getPositionName } from 'services/Utilities'
import { List } from 'ui'
import { t } from 'translations'

const ShiftHistory = ({ diffs, timeZone }) => {
  // Sort and remove diffs that don't actually contain anything
  // This is to fix any diffs made before august 2021, can be removed in 2022 ish.
  // The diffs from before this period could sometimes save diffs for a field that hadn't changed.
  const sortedDiffs = orderBy(
    diffs
      .map(diff => {
        if (!diff.values) return diff
        diff.values = diff.values.filter(value => JSON.stringify(value.before) !== JSON.stringify(value.after))
        if (!diff.values.length) return null
        return diff
      })
      .filter(Boolean),
    ['lastUpdated']
  )
  const noValue = value => !value || value === ''

  const formatDate = date => {
    if (noValue(date)) return date
    try {
      return Format(Parse(date), { outFormat: 'humanDateTime' })
    } catch (error) {
      return date
    }
  }

  const parseValue = ({ property, before, after }) => {
    let transKey = ''

    switch (property) {
      case 'employeeId':
        if (noValue(before)) transKey = 'EMPLOYEEID_ASSIGNED'
        else if (noValue(after)) transKey = 'EMPLOYEEID_UNASSIGNED'
        else transKey = 'EMPLOYEEID_CHANGED'
        before = getUserName(before)
        after = getUserName(after)
        break
      case 'positionId':
        transKey = 'POSITIONID_CHANGED'
        before = getPositionName(before)
        after = getPositionName(after)
        break
      case 'start':
        transKey = 'START_CHANGED'
        before = formatDate(before)
        after = formatDate(after)
        break
      case 'end':
        transKey = 'END_CHANGED'
        before = formatDate(before)
        after = formatDate(after)
        break
      case 'comment':
        if (noValue(before)) transKey = 'COMMENT_ADDED'
        else if (noValue(after)) transKey = 'COMMENT_REMOVED'
        else transKey = 'COMMENT_CHANGED'
        break
      case 'finalized':
        if (noValue(after)) transKey = 'UNFINALIZED'
        else transKey = 'FINALIZED'
        break
      case 'resolved':
        if (noValue(after)) transKey = 'UNRESOLVED'
        else transKey = 'RESOLVED'
        break
      case 'cancelled':
        if (noValue(after)) transKey = 'RESTORED'
        else transKey = 'CANCELLED'
        break
      case 'published':
        if (noValue(after)) transKey = 'UNPUBLISHED'
        else transKey = 'PUBLISHED'
        break

      case 'isExtraShift':
      case 'isOvertime':
      case 'isOnCall':
      case 'isIrreplaceable':
      case 'needsReplacement':
      case 'noEmployeeAvailable':
      case 'hasSpecificRequirements':
      case 'coveredOtherUnit':
      case 'projects':
      case 'departments':
      case 'breaks':
      case 'wagePremiums':
      case 'requiredAttributes':
      case 'billingDetails':
      case 'tags':
        transKey = `${property.toUpperCase()}_CHANGED`
        break
      case 'contactListId':
        transKey = `ADDED_TO_CONTACT_LIST`
        break
      default:
        break
    }

    if (transKey === '') return null

    return (
      <>
        {/* {property}: {before} -> {after} */}
        <Trans t={t} i18nKey={`manager.schedule.EDIT_MODAL.HISTORY_DIFFS.${transKey}`}>
          <b>{{ before }}</b>
          <b>{{ after }}</b>
        </Trans>
      </>
    )
  }

  return (
    <List className="mt-2">
      {sortedDiffs.map(({ lastUpdated, by, created, viewedByUser, values = [], reason = {} }, index) => {
        let action = 'EDITED'
        if (created) action = 'CREATED'
        if (viewedByUser) action = 'VIEWED_BY_USER'
        return (
          <List.Item key={index}>
            {/* Show who and when */}
            <Trans t={t} i18nKey={`manager.schedule.EDIT_MODAL.HISTORY_DIFFS.${action}`}>
              <b>{{ name: getUserName(by) }}</b>
              <b>{{ time: Format(lastUpdated, { outFormat: 'time', isUTC: true, timeZone }) }}</b>
              {{ date: Format(lastUpdated, { outFormat: 'humanDate', isUTC: true, timeZone }) }}
            </Trans>

            {/* Reason for change */}
            {reason.text && reason.text.length ? (
              <div>
                <Trans t={t} i18nKey={`manager.schedule.EDIT_MODAL.REASON_FOR_CHANGE${reason.description && reason.description.length ? '_DESCRIPTION' : ''}`}>
                  <b>{{ reason: t(`manager.schedule.CHANGE_REASONS.${(reason.text || '').replace('scheduleFiltering.', '').toUpperCase()}`) }}</b>
                  <i>{{ description: reason.description }}</i>
                </Trans>
              </div>
            ) : reason.description?.length ? (
              <div>
                <Trans t={t} i18nKey={`manager.schedule.EDIT_MODAL.REASON_FOR_CREATION`}>
                  <i>{{ description: reason.description }}</i>
                </Trans>
              </div>
            ) : null}

            {/* Show what changed */}
            {values.map((value, index) => (
              <div key={index}>{parseValue(value)}</div>
            ))}
          </List.Item>
        )
      })}
    </List>
  )
}

const mapStateToProps = ({ settings }) => ({ timeZone: settings.defaultTimeZone })
const mapDispatchToProps = () => ({})

export default connect(mapStateToProps, mapDispatchToProps)(ShiftHistory)

ShiftHistory.defaultProps = { diffs: [] }
